const contentTypeEnum = {
    Genially: "Genially",
    Youtube: "Youtube",
    Image: "Image",
    Pdf: "Pdf",
};

export default contentTypeEnum;
